import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Projectcolors from "../../Utils/Colors";
import { baseURL } from "../../Config/config";
import { Typography, Link } from "@mui/material";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import OutlinedInput from "@mui/material/OutlinedInput";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import model from "../../images/SelexRisk.jpeg";
import Arrow from "../../images/arrow.png";
import { InputLabel, Select, MenuItem } from "@mui/material";

import Excel from "../../images/SelexRISK.png";
import Hysys from "../../images/hysys.jpeg";
import Gui from "../../images/optimize.jpeg";
import jsonimage from "../../images/json.png";

import { makeStyles } from "@mui/styles";
import GlobalLoader from ".././CommonC/GlobalLoader";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";
import axios from "axios";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          sx={{ fontSize: 14 }}
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

LinearProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number.isRequired,
};

const useStyles = makeStyles({
  button: {
    textTransform: "none",
  },
});

function PredictionRisk(props) {
  const [independent, setIndependent] = React.useState([]);
  const [dependent, setDependent] = React.useState(["P_f_3m_pct", "P_f_6m_pct", "P_f_9m_pct","lambda_base_per_day","lambda_multiplier","lambda_adj_per_day"]);
  const [values, setValues] = React.useState([]);
  const [getvalues, setgetValues] = React.useState([]);
  const [predicted, setPredicted] = React.useState(["",""]);
  
  const [isCompleted, setisCompleted] = React.useState(false);

  const [modalTraining, setmodalTraining] = React.useState(false);
  const [getLoader, setGetLoader] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [inputopen, setinputOpen] = React.useState(false);
  const [errdownload, seterrdownload] = React.useState(false);
  const [mess, setmess] = React.useState(false);
  const [fpmess, setfpmess] = React.useState(false);
  const [falsewarning, setfalsewarning] = React.useState(false);
  
  const [progress, setProgress] = React.useState(0);
  const [trained, setTrained] = React.useState(false);
  const [equipmentTypes, setequipmentTypes] = useState(["hey", "hello"]);
  const [filter, setFilter] = useState("Vessel");
  const equipmentInputs = {
  "Vessel": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "corrosion_rate_mm_per_y", "shell_min_thickness_mm"
  ],

  "Column": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "flooding_indicator_pct", "column_dp_kpa"
  ],

  "Heat Exchangers": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "fouling_factor", "tubes_plugged_count"
  ],

  "Reactors": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "hot_spot_temp_C", "bed_dp_kpa", "catalyst_activity_index"
  ],

  "Air Cooler": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "fan_vibration_mm_s", "fin_cleanliness_index"
  ],

  "Fired Heaters": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "tube_metal_temp_C", "stack_O2_pct"
  ],

  "Control Valves": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "travel_deviation_pct", "hysteresis_pct", "leakage_class"
  ],

  "Pumps": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "vibration_overall_mm_s", "seal_leak_rate_lph"
  ],

  "Compressors": [
    "MTBF_days", "failures_last_3y", "availability_pct",
    "PM_compliance_pct", "unplanned_downtime_hours_last_12m",
    "failures_last_3m", "failures_last_6m", "failures_last_1y",
    "RBI_risk", "surge_margin_pct", "discharge_temp_C", "polytropic_eff_pct"
  ]
};


const handleEquipmentChange = (newfilter) => {
    setFilter(newfilter);
    setIndependent(equipmentInputs[newfilter]);
  };


  

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    seterrdownload(false);
  };

  const handleermessageOpen = () => {
    setmess(true);
  };
  const handleMessage = () => {
    setmess(false);
    seterrdownload(false);
  };
  const handlefpMessage = () => {
    setfpmess(false);
    seterrdownload(false);
  };

  const handleallClose = () => {
    setinputOpen(false);
    seterrdownload(false);
  };

  const handleerrClickOpen = () => {
    seterrdownload(true);
  };

  const handleerrClose = () => {
    seterrdownload(false);
  };

  const handlefalsewarningOpen = () => {
    setfalsewarning(true);
  };

  const handlefalsewarningClose = () => {
    setfalsewarning(false);
  };

  React.useEffect(() => {
    getRiskData();
    
  }, []);

  

  const getRiskData = () => {
    setGetLoader(true);
    if (props.loaded) {
      sessionStorage.setItem("projectID", props.ProjectID);
    }
    const projectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getRiskData?projectID=${projectID}&loaded=${props.loaded}`
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("data", data);
        setequipmentTypes(data.equipmentTypes);
        setFilter(data.filter)
        setgetValues(data.values)
        setValues(data.values)
        setIndependent(equipmentInputs[data.filter])

        if (data.predicted) {
          setPredicted(data.predicted);

          
        }
        setGetLoader(false);

      })
      .catch((err) => {
        setGetLoader(false);
      });
  };
  console.log(getvalues);

  const handleChange = (event, idx) => {
    const dataArray = Array.from(values);
    dataArray[idx] = event.target.value;
    setValues(dataArray);
  };
  console.log(values)

  function checkinput() {
    var isnulll = false;
    if (values.length === 0 || values.length < independent.length) {
      setinputOpen(true);
      isnulll = true;
    }
    if (values.length === independent.length) {
      for (var i = 0; i < values.length; i++) {
        if (values[i] === "" || values[i] === null) {
          setinputOpen(true);
          isnulll = true;
        }
      }
    }
    if (isnulll === false) {
      predict();
    }
  }
  let timer;
  const predict = () => {
    const projectID = sessionStorage.getItem("projectID");
    console.log("In predict");
    const valuesObj = equipmentInputs[filter].reduce((acc, key, index) => {
  acc[key] = values[index];
  return acc;
}, {});

    const body = JSON.stringify({
      filter,
      values,
      valuesObj,
      projectID,
      time: new Date(),
    });
    setProgress(0);
    setTrained(false);
    setmodalTraining(true);
    const config = {
      onUploadProgress: (progressEvent) => {
        let seconds = 1000;
        timer = setInterval(() => {
          setProgress((prevProgress) =>
            prevProgress >= 99 ? 99 : prevProgress + 1
          );
        }, seconds);
      },
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios
      .post(`${baseURL}/predictrisk?projectID=${projectID}`, body, config)
      .then((response) => response)
      .then((result) => {
        const data = result.data
        console.log("dataaaa",result.data)
        if (data.predicted) {
          setPredicted(data.predicted);
          setmodalTraining(false);
          clearInterval(timer);
          setTrained(true);
          setProgress(100);
        } else {
          setfalsewarning(true);
          setmodalTraining(false);
          clearInterval(timer);
          setTrained(false);
        }
      })
      .catch((error) => {
        if (mess === false) {
          setfalsewarning(true);
        }
        clearInterval(timer);
        setTrained(false);

        setmodalTraining(false);
        console.error("Error:", error);
      });
  };

  function downloadPredictions() {
      const projectID = sessionStorage.getItem("projectID");
      const projectName = sessionStorage.getItem("projectName");
      setGetLoader(true);
      fetch(
        `${baseURL}/downloadpredictions?projectID=${projectID}&projectName=${projectName}`
      )
        .then((res) => res.blob())
        .then((blob) => {
          var file = new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var url = URL.createObjectURL(file);
          var link = document.createElement("a");
          link.download = projectName + ".xlsx";
          link.href = url;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          fetch(`${baseURL}/deleteriskfile?projectID=${projectID}`, {
            method: "POST",
            body: JSON.stringify(projectName),
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((result) => {
              setGetLoader(false);
            })
            .catch((error) => {
              console.error("Error:", error);
              setGetLoader(false);
            });
          setGetLoader(false);
        })
        .catch((err) => {
          setGetLoader(false);
          seterrdownload(true);
          console.log("Error", err);
        });
    }

  const classes = useStyles();

  return (
    <div style={{ marginTop: "1px" }}>
      <Dialog
        open={falsewarning}
        onClose={handlefalsewarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"Prediction Failed"}
        </DialogTitle>
      </Dialog>

      <Dialog
        open={inputopen}
        onClose={handleallClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"All Inputs require to predict new values"}
        </DialogTitle>
      </Dialog>
      <Dialog
        open={errdownload}
        onClose={handleerrClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {"Error Downloading !"}
        </DialogTitle>
      </Dialog>
      
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "red", fontSize: "13px" }}
        >
          {
            "            Incomplete Project ! Project Report Cannot be Downloaded"
          }
        </DialogTitle>
      </Dialog>

       
          <Box
            component={Paper}
            elevation={10}
            //m="auto"
            sx={{
              height: 530,
              width: 1120,
              padding: 2,
              display: "flex",
              flexDirection: "row",
               marginTop: "45px",
                   marginLeft: "15%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                border: 0,
                width: 1030,
                height: 450,
              }}
            >
             
                <div>
               
                <div
                  //onClick={() => downloadPredictions()}
                  style={{
                    //display: "flex",
                    //flexDirection: "row",
                    //alignItems: "center",
                    float: "right",
                    ml: 100,
                    cursor: "pointer",
                     marginTop: "45px",
                   marginLeft: "50%",
                   border:1
                  }}
                >
                   
                  {/*<DownloadIcon
                    sx={{
                      fontSize: "medium",
                      marginTop: 1,
                      mb: 1,
                      mr: 0.5,
                      color: Projectcolors.primary,
                    }}
                  /> */}
                  <Link
                    sx={{
                      fontSize: "13px",
                      fontStyle: "bold",
                      float: "right",
                      ml: 0,
                      mr: 0.5,
                      // marginTop: 0,
                      // marginBottom: 1,
                      textTransform: "none",
                    }}
                    variant="contained"
                    size="large"
                    textTransform="none"
                    href="https://drive.google.com/file/d/18Gc8rYngddaDFO2Yj21AXCwKOMKbw-hA/view?usp=sharing"
                     
                  >
                    <img
                                      alt ="arrow"
                                      src={Excel}
                                      style={{
                                        marginTop: 0,
                                        marginBottom: 1,
                                        marginRight: 0,
                                        width:60,
                                        height:50
                                      }}
                                    />
                    <span style={{marginLeft:0}}> Download Predictable GUI</span>
                  </Link>
                </div>
                
                </div>

              

              


              <Box
                m="auto"
                sx={{
                  width: 1050,
                  // height: 390,
                  display: "flex",
                  flexDirection: "row",
                   marginLeft: "5%",

                  
                }}
              >
                {/* LEFT DIV */}
                <Box
                  sx={{
                    width: 230,
                    height: 310,
                    marginBottom: "30px",
                    // marginRight: "10px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      position: "relative",
                      top: 8,
                      left: 15,
                      width: 155,
                    }}
                  >
                    <Typography sx={{ fontSize: "13PX", fontWeight: "bold" }}>
                      &nbsp;&nbsp;Independent Variables
                    </Typography>
                  </div>
                  <Box
                    sx={{
                      width: 230,
                      height: 310,
                      marginTop: "0px",
                      border: 1,
                      borderColor: Projectcolors.primary,
                      padding: 1,
                      overflowY: "scroll",
                      marginLeft: "1px",
                      marginRight:"1px"
                    }}
                  >
                    {/* Dropdown filter */}
                                
                    <div>
                        <FormControl  sx={{
                                      float: "right",
                                      marginRight: 2,
                                      marginTop: 2,
                                      marginBottom:1,
                                      marginLeft: 1,
                                      width: 160,
                                    }}
                                    size="small" >
                                  <InputLabel sx={{fontSize:12}}>Equipment Type</InputLabel>
                                  <Select
                                    value={filter}
                                    label="Equipment Type"
                                    onChange={(e) => handleEquipmentChange(e.target.value)}
                                    sx={{
                                        width: "135px",
                                        fontSize: "11px",
                                        height: "30px",
                                      }}
                                  >
                                    {equipmentTypes.map((type) => (
                                      <MenuItem key={type} value={type}>
                                        {type}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                      {getvalues.length > 0

                        ? 
                        independent.map((item, i) => {
                            return (
                              <div>
                              
                                  <FormControl
                                    sx={{
                                      float: "right",
                                      marginRight: 2,
                                      marginTop: 1,
                                      marginLeft: 1,
                                      width: 160,
                                    }}
                                    size="small"
                                  >
                                    <Typography sx={{ fontSize: 11 }}>
                                      {independent[i]}
                                    </Typography>

                                    <OutlinedInput
                                      id="outlined-basic"
                                      variant="outlined"
                                      placeholder=""
                                      sx={{
                                        width: "135px",
                                        fontSize: "11px",
                                        height: "30px",
                                      }}
                                      onChange={(e) => {
                                        handleChange(e, i);
                                      }}
                                      defaultValue={getvalues[i]}
                                      size="small"
                                    />
                                    <img
                                    alt ="arrow"
                                      src={Arrow}
                                      style={{
                                        width: "150px",
                                        height: "28px",
                                        marginTop: 1,
                                        // marginRight:5
                                        // backgroundColor:"red"
                                      }}
                                    />
                                  </FormControl>
                               
                              </div>
                            );
                          })
                        : 
                        independent.map((item, i) => {
                          return (
                            <div>
                             
                                <FormControl
                                  sx={{
                                    float: "right",
                                    marginRight: 2,
                                    marginTop: 1,
                                    marginLeft: 1,
                                    width: 160,
                                  }}
                                  size="small"
                                >
                                  <Typography sx={{ fontSize: 11 }}>
                                    {independent[i]}
                                  </Typography>

                                  <OutlinedInput
                                    id="outlined-basic"
                                    variant="outlined"
                                    placeholder=""
                                    sx={{
                                      width: "135px",
                                      fontSize: "11px",
                                      height: "30px",
                                    }}
                                    onChange={(e) => {
                                      handleChange(e, i);
                                    }}
                                    //defaultValue={getvalues[i]}
                                    size="small"
                                  />
                                  <img
                                  alt ="arrow"
                                    src={Arrow}
                                    style={{
                                      width: "150px",
                                      height: "28px",
                                      marginTop: 1,
                                      // marginRight:5
                                      // backgroundColor:"red"
                                    }}
                                  />
                                </FormControl>
                              
                            </div>
                          );
                        })
                        

                          
                          
                          }

                          
                    </div>
                  </Box>
                </Box>
                {/* CENTER DIV */}
                <Box sx={{ height: 390 }}>
                  <Box
                    sx={{
                      width: 355,
                      height: 310,
                      padding: 5,
                      boxShadow: 9,
                      border: 1,
                      borderWidth: "4px",
                      borderColor: Projectcolors.primary,
                      borderRadius: 3,
                      fontSize: 20,
                      textAlign: "center",
                      marginTop: 3,
                      marginRight: 1,
                      marginLeft:2
                    }}
                  >
                    <Typography sx={{ fontSize: "13px" }}>
                      SelexRisk POF Calculation
                    </Typography>

                    <img
                    alt ="model"
                      src={model}
                      style={{
                        marginTop: 40,
                        objectFit: "contain",
                        height: "130px",
                      }}
                    />
                  </Box>
                  <Box sx={{ height: "40px" }}>
                    <Button
                      onClick={() => checkinput()}
                      disabled={!props.editAccess}
                      mr={4}
                      sx={{
                        width: 140,
                        height: 35,
                        fontSize: "12px",
                        backgroundColor: Projectcolors.primary,
                        color: "#fff",
                        fontStyle: "bold",
                        marginBottom: 5,
                        float: "left",
                        ml: 1,
                        marginTop: 2,
                        textTransform: "none",
                      }}
                      variant="contained"
                      size="large"
                      textTransform="none"
                    >
                      Run SelexMB
                    </Button>
                    {/**
                    <Link
                    sx={{
                      fontSize: "13px",
                      fontStyle: "bold",
                      float: "right",
                      ml: 0,
                      mr: 0.5,
                      mt:4,
                      // marginTop: 0,
                      // marginBottom: 1,
                      textTransform: "none",
                    }}
                    variant="contained"
                    size="large"
                    textTransform="none"
                    href="/tcpserver"
                     
                  >

                          
                   
                    <span style={{marginLeft:2,marginRight:10}}>Real Time Prediction</span>
                   
                  </Link>
                   */}
                  </Box>
                </Box>
                {/* RIGHT DIV */}
                <Box
                  sx={{
                    width: "365px",
                    height: 310,
                    marginTop: "0px",
                    marginLeft: "10px",
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      position: "relative",
                      top: 8,
                      left: 15,
                      width: 143,
                    }}
                  >
                    <Typography sx={{ fontSize: "13px", fontWeight: "bold" }}>
                      &nbsp;&nbsp;Dependent Variables
                    </Typography>
                  </div>
                  <Box
                    sx={{
                      width: "376px",
                      height: 310,
                      marginTop: "2px",
                      border: 1,
                      borderColor: Projectcolors.primary,
                      padding: 1,
                      overflowY: "scroll",
                      marginLeft: "1px",
                    }}
                  >
                    
                    
                    {
                        predicted.length >0?( 
                            dependent.map((item, i) => {
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 1,
                          }}
                        >
                          <Box sx={{ width: 260 }}>
                            <Typography
                              sx={{ fontSize: "11px", marginLeft: 1 }}
                            >
                              {item} 
                            </Typography>
                            <Typography>
                              <img
                              alt ="arrow"
                                src={Arrow}
                                style={{
                                  width: "160px",
                                  height: "28px",
                                  marginTop: 0,
                                  marginLeft: "8px",
                                  // marginRight:5
                                  // backgroundColor:"red"
                                }}
                              />
                            </Typography>
                          </Box>
                          <Box>
                            <FormControl
                              sx={{
                                float: "left",
                                marginTop: 0,
                                marginLeft: 0,
                                marginRight: 3,
                              }}
                              variant="outlined"
                              size="small"
                            >
                              <OutlinedInput
                                sx={{
                                  width: "135px",
                                  fontSize: "11px",
                                  height: "30px",
                                  marginTop: 2,
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                value={predicted[i]}
                                placeholder=" "
                                size="small"
                              />
                            </FormControl>
                          </Box>
                        </Box>
                      )})):(
                    dependent.map((item, i) => {
                      return (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 1,
                          }}
                        >
                          <Box sx={{ width: 260 }}>
                            <Typography
                              sx={{ fontSize: "11px", marginLeft: 1 }}
                            >
                              {item} 
                            </Typography>
                            <Typography>
                              <img
                              alt ="arrow"
                                src={Arrow}
                                style={{
                                  width: "160px",
                                  height: "28px",
                                  marginTop: 0,
                                  marginLeft: "8px",
                                  // marginRight:5
                                  // backgroundColor:"red"
                                }}
                              />
                            </Typography>
                          </Box>
                          <Box>
                            <FormControl
                              sx={{
                                float: "left",
                                marginTop: 0,
                                marginLeft: 0,
                                marginRight: 3,
                              }}
                              variant="outlined"
                              size="small"
                            >
                              <OutlinedInput
                                sx={{
                                  width: "135px",
                                  fontSize: "11px",
                                  height: "30px",
                                  marginTop: 2,
                                }}
                                id="outlined-basic"
                                variant="outlined"
                                value={predicted ? predicted[i] : null}
                                placeholder=" "
                                size="small"
                              />
                            </FormControl>
                          </Box>
                        </Box>
                      );
                    
                    
                    }) 
                    )
                    }
                
                  </Box>
                  
                </Box>
              </Box>
              {modalTraining ? (
                  <Box
                    sx={{
                      width: "98%",
                      float: "left",
                      marginBottom: 0,
                      height: "10px",
                      marginTop: "0px",
                    }}
                  >
                    <LinearProgressWithLabel
                      value={progress}
                      sx={{ height: "6px" }}
                    />
                  </Box>
                ) : null}

                {trained ? (
                  <Box
                    sx={{
                      width: "98%",
                      float: "left",
                      marginBottom: 0,
                      height: "10px",
                      marginTop: "0px",
                    }}
                  >
                    <LinearProgressWithLabel
                      value={100}
                      sx={{ height: "6px" }}
                    />
                  </Box>
                ) : null}
              <Box>
                
              </Box>
            </Box>
          </Box>

         

      {getLoader ? <GlobalLoader /> : null}
    </div>
  );
}

export default PredictionRisk;
